import React from 'react'
import { useLocation } from 'react-router-dom';

export function LeftRightlayout({ Content, RightImg }) {

  const location = useLocation();



  return (
    <>
      <div className="flex leftContainer" >
        <div className={`w-32P shadow-leftShadow relative h-screen ${ location?.pathname === "/service" ? "se" : "" }`}>
          {Content()}
        </div>
        <div className="bg-scogolightwhite m-auto h-screen w-68P rightContainer" >
        {RightImg()}
        </div>
      </div>

    </>
  )
}
